function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as t } from "./index.es33.js";
import { useState as I, useRef as g, useCallback as _, useMemo as k } from "react";
import { clsx as p } from "./index.es105.js";
import { useClickAway as A } from "./index.es130.js";
import { selectSelectors as T } from "./index.es158.js";
import "./index.es133.js";
import "react-dom";
import { isEmpty as V } from "./index.es159.js";
import "./index.es134.js";
import { Typography as f } from "./index.es35.js";
import "./index.es36.js";
import { SelectControl as q } from "./index.es160.js";
import { Option as F } from "./index.es161.js";
import { OptionGroup as J } from "./index.es162.js";
import { CheckboxOption as Q } from "./index.es163.js";
import { PopupMenu as U } from "./index.es136.js";
import { SelectSize as x, SelectKind as v } from "./index.es135.js";
import X from "./index.es132.js";
import { useKeyboardNavigation as Y, usePopupPosition as Z } from "./index.es164.js";
import { ColorSchemeStylesMap as l, ColorSchemeButtonStylesMap as $ } from "./index.es165.js";
import e from "./index.es166.js";

var n = function n(_ref) {
  var _p3, _p4;

  var _ref$kind = _ref.kind,
      r = _ref$kind === void 0 ? v.outline : _ref$kind,
      _ref$size = _ref.size,
      B = _ref$size === void 0 ? x.normal : _ref$size,
      _ref$isDisabled = _ref.isDisabled,
      a = _ref$isDisabled === void 0 ? !1 : _ref$isDisabled,
      _ref$isError = _ref.isError,
      m = _ref$isError === void 0 ? !1 : _ref$isError,
      _ref$placeholder = _ref.placeholder,
      P = _ref$placeholder === void 0 ? "Select..." : _ref$placeholder,
      _ref$isClearable = _ref.isClearable,
      M = _ref$isClearable === void 0 ? !1 : _ref$isClearable,
      _ref$preventCloseOnSe = _ref.preventCloseOnSelect,
      i = _ref$preventCloseOnSe === void 0 ? !1 : _ref$preventCloseOnSe,
      b = _ref.className,
      R = _ref.children,
      u = _ref.value,
      h = _ref.label,
      y = _ref.hint,
      C = _ref.onOptionClick,
      W = _ref.onChangeOpenState,
      c = _ref.withButton,
      w = _ref.isHideOptions,
      _ref$isTruncated = _ref.isTruncated,
      j = _ref$isTruncated === void 0 ? !1 : _ref$isTruncated,
      H = _ref.isLoading,
      K = _ref.forcedOpen;

  var _ref2 = K || I(!1),
      _ref3 = _slicedToArray(_ref2, 2),
      o = _ref3[0],
      s = _ref3[1],
      N = g(null),
      d = g(null),
      L = function L(S) {
    S.key === "space" && s(!o);
  },
      z = function z() {
    s(!o);
  },
      O = _(function (S) {
    return i || s(!1), C === null || C === void 0 ? void 0 : C(S);
  }, [i, C]),
      G = k(function () {
    return {
      onOptionClick: O,
      isOpen: o,
      value: u || null,
      setIsOpen: s,
      preventCloseOnSelect: !!i
    };
  }, [u, O, i, o]);

  return A(d, function () {
    o && s(!1);
  }), Y({
    setOpen: s,
    isOpen: o,
    target: d.current
  }), Z({
    isOpen: o,
    popupRef: N,
    onChangeOpenState: W
  }), t.jsx(X.Provider, {
    value: G,
    children: t.jsxs("div", {
      className: p(e.wrapper, b, T.classNames.controlWrapper, _defineProperty({}, e.wrapperTruncated, j)),
      children: [h && t.jsx(f.Body2, {
        as: "div",
        className: e.label,
        children: h
      }), t.jsxs("div", {
        className: p(e.inner, _defineProperty({}, e.innerWithButton, !!c)),
        ref: d,
        children: [t.jsx(f.Body2, {
          as: "div",
          onClick: a ? void 0 : z,
          onKeyDown: L,
          className: p("select__control", e.selectControl, l[r].styles, (_p3 = {}, _defineProperty(_p3, l[r].valuedStyles, !V(u)), _defineProperty(_p3, l[r].errorStyles, m), _defineProperty(_p3, l[r].disabledStyles, a), _defineProperty(_p3, e.selectControlLarge, B === x.large), _defineProperty(_p3, e.selectControlOpened, o), _defineProperty(_p3, e.selectControlWithButton, !!c), _p3)),
          children: t.jsx(q, {
            isDisabled: a,
            toggleIsOpen: function toggleIsOpen() {
              return s(!o);
            },
            placeholder: P,
            isClearable: M,
            isTruncated: j,
            isLoading: H
          })
        }), c && t.jsx(f.Body2, {
          className: p(e.button, l[r].styles, $[r], (_p4 = {}, _defineProperty(_p4, l[r].errorStyles, m), _defineProperty(_p4, l[r].disabledStyles, a), _p4)),
          as: "div",
          children: c
        }), y && t.jsx(f.Small, {
          className: p(e.hint, _defineProperty({}, e.errorHint, m)),
          "data-error": m,
          children: y
        }), o && !w && t.jsx("ul", {
          className: p(e.optionsListPopup, _defineProperty({}, e.optionsListPopupWithHint, !!y)),
          ref: N,
          children: R
        })]
      })]
    })
  });
};

n.CheckboxOption = Q;
n.OptionGroup = J;
n.Option = F;
n.PopupMenu = U;
n.kind = v;
n.size = x;
export { n as Select };